import React from "react";
import PropTypes from "prop-types";
import SvgIcon from "@mui/material/SvgIcon";

export default function ArrowDownIcon(props) {
  return (
    <SvgIcon width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <path d="M13.4329 11.075L10.5627 13.9452C10.4708 14.0371 10.3781 14.1025 10.2847 14.1415C10.1912 14.1805 10.0942 14.2 9.9938 14.2C9.89337 14.2 9.79642 14.1805 9.70295 14.1415C9.60946 14.1025 9.51678 14.0371 9.4249 13.9452L6.53388 11.0542C6.40461 10.9249 6.33997 10.7716 6.33997 10.5943C6.33997 10.4169 6.41155 10.2567 6.55472 10.1135C6.69787 9.97035 6.85679 9.89876 7.03147 9.89876C7.20613 9.89876 7.36505 9.97035 7.50822 10.1135L9.32715 11.9324L9.32715 6.46926C9.32715 6.29191 9.39392 6.13647 9.52747 6.00293C9.66101 5.86939 9.81645 5.80262 9.9938 5.80262C10.1711 5.80262 10.3266 5.86939 10.4601 6.00293C10.5937 6.13647 10.6604 6.29191 10.6604 6.46926V11.9324L12.5002 10.0927C12.6295 9.9634 12.7828 9.89876 12.9602 9.89876C13.1375 9.89876 13.2978 9.97035 13.4409 10.1135C13.5841 10.2567 13.6565 10.4148 13.658 10.5878C13.6596 10.7609 13.5846 10.9233 13.4329 11.075Z" fill={props.color}/>
    </SvgIcon>
  );
}

ArrowDownIcon.propTypes = {
  color: PropTypes.string
};